<template>
  <span
    v-if="firstPrice"
    class="body-2 bg-static-info-low inline-flex items-center gap-4 rounded-full ml-4 px-4 py-2 relative bottom-4"
  >
    {{ i18n(translations.plan, { price: i18n.price(firstPrice.price) }) }}
    <RevIllustration
      :alt="mobilePlan.partner?.name"
      :height="16"
      src="/img/bouygues/bouyguesLogoSquare.svg"
      :width="16"
    />
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-partnerships/mobile-plan/types/mobile-plan-offers'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'
import type { ReadonlyObjectDeep } from 'type-fest/source/readonly-deep'

import translations from './MobilePlanPrice.translations'

const props = defineProps<{
  mobilePlan: ReadonlyObjectDeep<MobilePlanOffer>
}>()

const i18n = useI18n()

const firstPrice = computed(() => {
  return props.mobilePlan.priceOptions.find(
    ({ option }) => option === 'KEEP_PHONE_NUMBER',
  )?.prices[0]
})
</script>
